import { Observable } from 'rxjs';

export interface MgtBgtAcctGetListsParams {
  major: string,
  sub_major: string,
  ledger: string,
  sub_obj: string
}

export interface MgtBgtAcctDetails {
  acct_id: any,
  acct_title: string,
  acct_uacs_code: string,
  acct_group: string,
  major_group: string,
  sub_major_group: string,
  ledger_acct: string,
  sub_object_code: string
}

export interface ManageApiResponse {
  code: number,
  message: any
}

export interface MgtBgtAcctSave { uacs: string, name: string }

export interface MgtBgtAcctUpdate { acct_id: string, uacs: string, name: string }

export abstract class ManageBudgetAccount {
  abstract getLists(param: MgtBgtAcctGetListsParams): Observable<ManageApiResponse>;
  abstract save(params: MgtBgtAcctSave): Observable<ManageApiResponse>;
  abstract delete(id: string | number): Observable<ManageApiResponse>;
  abstract update(params: MgtBgtAcctUpdate): Observable<ManageApiResponse>;
}
